export default "__VITE_ASSET__BGp4brP0__"